import { css } from 'styled-components';
import token from 'styled-token';
import { StyledListboxOptionMedia } from '../../components/ListboxOptionMedia/ListboxOptionMedia.styles';
import { typographyMixin } from '../typographyMixin';
import { ListboxOptionMixin } from './ListboxOptionMixin';
import { VisuallyHiddenMixin } from './VisuallyHiddenMixin';
export var ListboxGroupLabelMixin = function ListboxGroupLabelMixin(props) {
  return token({
    fontType: 'ListboxGroupLabel.fontType',
    fontColor: 'ListboxGroupLabel.fontColor',
    backgroundColor: 'ListboxGroupLabel.backgroundColor',
    textTransform: 'ListboxGroupLabel.textTransform'
  }, function (_ref) {
    var fontType = _ref.fontType,
      fontColor = _ref.fontColor,
      backgroundColor = _ref.backgroundColor,
      _ref$textTransform = _ref.textTransform,
      textTransform = _ref$textTransform === void 0 ? 'uppercase' : _ref$textTransform;
    return css(["", " ", " cursor:default;text-transform:", ";background-color:", ";&,", "{color:", ";}", ""], ListboxOptionMixin(props), typographyMixin(Object.assign({
      fontType: fontType
    }, props)), textTransform, backgroundColor, StyledListboxOptionMedia, fontColor, props.visuallyHidden ? VisuallyHiddenMixin(props) : '');
  })(props);
};